import * as React from 'react';
import * as Commonmark from 'react-commonmark';
import { MdAdd, MdRemove } from 'react-icons/md';

interface IQuestionState {
  showAnswer: boolean;
}

interface IQuestionProps {
  question: IQuestion;
}

interface IQuestion {
  question: string;
  answer: string;
}

class Question extends  React.Component<IQuestionProps, IQuestionState> {
  constructor(props: IQuestionProps) {
    super(props);

    this.state = {
      showAnswer: false,
    };
  }

  public render() {
    const { question } = this.props;
    const { showAnswer } = this.state;

    return (
      <>
        <span onClick={this.toggleAnswer}>
          <strong>{question.question}</strong>
          {showAnswer ? <MdRemove className={'expand-icon pull-right'} size={30} /> : <MdAdd className={'expand-icon pull-right'} size={30} />}
        </span>

        {showAnswer && (
          <>
            <br />
            <Commonmark source={question.answer} />
          </>
        )}

      </>
    );
  }

  private toggleAnswer = () => {
    this.setState((prevState) => ({
      showAnswer: !prevState.showAnswer,
    }));
  }
}

export default Question;
